import { useWindow } from '@uds/hooks';

import('smoothscroll-polyfill').then(_ref => {
  let {
    polyfill
  } = _ref;
  polyfill();
});
const useSmoothScroll = () => {
  const window = useWindow();
  return selector => {
    const el = document.querySelector(selector);
    if (el != null) {
      const elRects = el.getBoundingClientRect();
      window.scrollBy({
        left: elRects.left,
        top: elRects.top,
        behavior: 'smooth'
      });
    }
  };
};

export { useSmoothScroll };
